import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import {
  getTransactionEft,
  getTransactionJPMorganDetails,
  getTransactionVendorCreditDetails,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";

import BillCreditItems from "./bill-credit/items";
import BillCreditBilling from "./bill-credit/billing";
import BillCreditRelationship from "./bill-credit/relationships";
import BillCreditCommunication from "./bill-credit/communication";
import BillCreditRelatedRecords from "./bill-credit/related-records";
import BillCreditSystemInformation from "./bill-credit/system-information";
import BillCreditCustom from "./bill-credit/custom";
import BillCreditEft from "./bill-credit/eft";
import BillCreditTaxReporting1 from "./bill-credit/tax-reporting1";
import BillCreditTaxReporting2 from "./bill-credit/tax-reporting2";
import BillCreditAvaTax from "./bill-credit/ava-tax";
import { GridComp4 } from "../../components/GridComponents";
import {
  CustomCheckBox,
  CustomCheckBoxComp126,
  CustomCheckBoxComp6,
} from "../../components/CheckboxComp";

export default function TransactionTypeBillCredit() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [jpMorganData, setJpMorganData] = useState([]);
  const pageDetail = slugMap[params.slug];
  const [eftData, seteftData] = useState([]);
  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [linkingdocumentno, setlinkingdocumentno] = useState("");

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocBillCreditDetailsData();
    }
  }, []);

  async function getTransactionDocBillCreditDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorCreditDetails(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details);
      setlinkingdocumentno(data.data.linkingdocumentno);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getJPMorganEftData(limit = 10, offset = 0) {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        tranid: params.docNo,
        limit,
        offset,
      });
      setJpMorganData(data.data.details[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  async function getTransactionEftData() {
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      seteftData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  useEffect(() => {
    if (user.token && tabIndex === 7) {
      getTransactionEftData();
    }
    if (user.token && tabIndex === 8) {
      getJPMorganEftData();
    }
  }, [tabIndex]);
  return loading ? (
    <>
     <Typography component="h4" fontWeight={500} className="pageTitle">
        Bill Credit
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Bill Credit
      </Typography>
      <Typography component="h5" style={{ marginBottom: 5 }}>
        <span className="para-no" style={{ marginBottom: 5 }}>
          <strong>{rowData[0]?.tranid}</strong> {rowData[0]?.vendor}
        </span>
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">TRANSACTION NUMBER</p>
                  <p className="tFormName">{d.transaction_number}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DATE</p>
                  <p className="tFormName">{d.date}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">REMITTANCE DESCRIPTION</p>
                  <p className="tFormName">{d.remittance_description}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">VENDOR</p>
                  <p className="tFormName">{d.vendor}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">POSTING PERIOD</p>
                  <p className="tFormName">{d.posting_period}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">AP COMMENTS</p>
                  <p className="tFormName">{d.ap_comments}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">VENDOR CREDIT/INVOICE NO.</p>
                  <p className="tFormName">{d.vendor_credit_invoice_number}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">AMOUNT</p>
                  <p className="tFormName">{d.amount}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SOURCE AP CHECK REQUEST</p>
                  <p className="tFormName">{d.source_ap_check_req}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PC/PROJECT</p>
                  <p className="tFormName">{d.pc_project}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
                  <p className="tFormName">{d.original_invoice_date}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">A/P ACCOUNT</p>
                  <p className="tFormName">{d.ap_account}</p>
                </Grid>
                {/* {d.linkingorderid === null || d.linkingorderid === "" ? (
                  <></>
                ) : (
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CREATED FROM</p>
                    <p className="tFormName">
                      {d.linkingfullname} <p className="link-color">#</p>
                      <Link
                        className="link-color"
                        target="_blank"
                        to={
                          "/transaction-type/" +
                          `${d.linkingtype}` +
                          "/" +
                          `${d.linkingorderid}`
                        }
                      >
                        {linkingdocumentno}
                      </Link>
                    </p>
                  </Grid>
                )} */}
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SPECIAL MAIL INSTRUCTIONS</p>
                  <p className="tFormName">{d.special_mail_instruction}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">NSC PO NUMBER</p>
                  <p className="tFormName">{d.nsc_po_number}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel checkAndTextAlign">
                    {d?.accrual_related === "false" ||
                    d?.accrual_related === null ? (
                      <>
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox disabled />}
                            label=""
                          />
                        </FormGroup>
                        ACCRUAL RELATED CREATED FROM
                      </>
                    ) : (
                      <>
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox checked disabled />}
                            label=""
                          />
                        </FormGroup>
                        ACCRUAL RELATED CREATED FROM
                      </>
                    )}
                  </p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SUBSIDIARY</p>
                  <p className="tFormName">{d.subsidiary}</p>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DEPARTMENT</p>
                  <p className="tFormName">{d.department}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SERVICE LINE</p>
                  <p className="tFormName">{d.service_line}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Billing" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="J.P.Morgan" />
            <Tab label="AvaTax" />
          </Tabs>

          {/*Items*/}
          <TabPanel value={tabIndex} index={0}>
            <BillCreditItems />
          </TabPanel>
          {/*Items*/}

          {/* Billing */}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 &&  <BillCreditBilling tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Billing */}

          {/* Relationship */}
          <TabPanel value={tabIndex} index={2}>
          {tabIndex === 2 &&   <BillCreditRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Relationship */}

          {/* Communication */}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 &&  <BillCreditCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* RelatedRecords */}
          <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 &&  <BillCreditRelatedRecords tabIndexP={tabIndex} />}
          </TabPanel>
          {/* RelatedRecords */}

          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <BillCreditSystemInformation />}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={6}>
          {tabIndex === 6 &&  <BillCreditCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Custom */}

          {/* Eft */}
          <TabPanel value={tabIndex} index={7}>
          {tabIndex === 7 &&  <BillCreditEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Eft */}

          {/* J>P morgan */}
          <TabPanel value={tabIndex} index={8}>
            {/* {tax_R_Data?.map((el, index) => ( */}
            {/* <Box className="viewDetilsBox" key={index}> */}
            <Box className="viewDetilsBox">
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN REFERENCE ID</p>
                  <p className="tFormName">{jpMorganData?.reference_id}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN STATUS</p>
                  <p className="tFormName">{jpMorganData?.status}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN MESSAGE</p>
                  <p className="tFormName">{jpMorganData?.message}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN UPDATED DATE</p>
                  <p className="tFormName">{jpMorganData?.updated_date}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN PAYER</p>
                  <p className="tFormName">{jpMorganData?.payer}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN TRANSACTION ID</p>
                  <p className="tFormName">{jpMorganData?.transaction_id}</p>
                </Grid>
              </Grid>
            </Box>
            {/* ))} */}
          </TabPanel>
          {/* Tax Reporting 1 */}

          {/* AvaTax */}
          <TabPanel value={tabIndex} index={9}>
          {tabIndex === 9 &&   <BillCreditAvaTax tabIndexP={tabIndex} />}
          </TabPanel>
          {/* AvaTax */}
        </Box>
      </Box>
    </>
  );
}
